import styled, { css } from 'styled-components';
import { zIndex } from 'styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

const {
  SPACING
} = Tokens;

export default {
  ContentWrapper: styled.span`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 100%;
    max-width: 100%;
    z-index: ${zIndex.BUTTON};
    overflow: hidden;
    justify-content: center;
    ${props => css`padding: ${props.iconButton ? 0 : `0 ${SPACING.SPACING_12}`};`}
    ${props => css`border-radius: ${props.iconButton ? '100%;' : '0;'}`}
    ${({ $fullWidth }) => $fullWidth && css`
      justify-content: center;
    `}
  `,
};